export default __webpack_public_path__ + "static/media/ply.0baeb2ce.svg";